<template>
  <div class="career-results content-container">
    <PageResultsIndicator class="hide-in-mobile" />
    <Loader v-if="initialLoad === true" />
    <ul
      v-if="getNumOfResults > 0"
      class="career-results__list"
    >
      <ListItem
        v-for="listItem in getCareerResults"
        :key="listItem.id"
        :title="listItem.title"
        :desc="listItem.descriptionPlain"
        :commitment="listItem.commitment"
        :location="listItem.location"
        :url="listItem.twLink"
      />
    </ul>
    <ul
      v-if="getNumOfResults === 0 && initialLoad === false"
      class="career-results__no-results"
    >
      <NoResults />
      <strong>No matching results</strong>
      Try using different filters or search terms
      <ClearFilters />
    </ul>
    <PageResultsIndicator v-if="getNumOfResults > 0" />
    <Pagination v-if="getNumOfResults > 10" />
  </div>
</template>

<script>
import ListItem from '@/components/subcomponents/results/ListItem.vue'
import PageResultsIndicator from '@/components/subcomponents/results/PageResultsIndicator.vue'
import Pagination from '@/components/subcomponents/pagination/Pagination.vue'
import NoResults from '@/components/subcomponents/svg/NoResults.vue'
import ClearFilters from '@/components/subcomponents/filters/ClearFilters.vue'
import Loader from '@/components/subcomponents/results/Loader.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CareerResults',
  components: {
    ListItem,
    Pagination,
    PageResultsIndicator,
    NoResults,
    ClearFilters,
    Loader
  },
  data () {
    return {
      initialLoad: true
    }
  },
  computed: {
    ...mapGetters({
      getKeyword: 'results/getKeyword',
      getResults: 'results/getResults',
      getResultsByKeyword: 'results/getResultsByKeyword',
      getNumOfResults: 'results/getNumOfResults',
      getNumOfCareers: 'results/getTotalNumOfCareers',
      getCurrent: 'pageNumber/getCurrent'
    }),
    getCareerResults () {
      return this.getKeyword !== '' ? this.getResultsByKeyword : this.getResults
    }
  },
  watch: {
    getCareerResults() {
      this.initialLoad = false
    }
  },
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;
@use 'variables';
@use 'utility' as *;

.career-results {
  flex: 1 1 auto;

  @include breakpoint-md {
    padding-left: 0;
    padding-right: 0;
  }

  &__list {
    margin-bottom: 2rem;
    padding: 0;
    margin-top: 0;
    margin-left: 0;

    @include breakpoint-md {
      margin-bottom: 1.5rem;
    }
  }

  &__no-results {
    font-size: 1em;
    text-align: center;
    line-height: 1.5;
    padding: 0;
    color: variables.$color-gray-3;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    strong {
      display: block;
      color: variables.$color-gray-5;
    }
  }
}

.careers--component .career-results {
  padding: 0;

  @include breakpoint-lg {
    padding: 0 1rem;
  }
}
</style>
